import React from "react";
import LoadingDots from "components/LoadingDots";
const CSS = require('./StripeLoading.less');

function StripeLoading() {
  return (
    <div className={CSS.Container}>
      <LoadingDots/>
      <span className={CSS.Message}>Loading <mark>Stripe Connect</mark>. <br/>Please wait a moment.</span>
    </div>
  );
}

export default StripeLoading;
